import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) {
  return _pushScopeId("data-v-cb4ab8ba"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "flow-percentage-container"
};
var _hoisted_2 = {
  class: "flow-percentage-wrapper"
};
var _hoisted_3 = {
  class: "flow-value-line"
};
var _hoisted_4 = {
  class: "flow-start"
};
var _hoisted_5 = {
  class: "flow-end"
};
import { unref } from "vue";
import { computed, onMounted, ref } from "vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'FlowPercentage',
  props: {
    flowCount: {
      default: 0
    },
    flowSurplus: {
      default: 0
    }
  },
  setup: function (__props) {
    var props = __props;
    var beforeMounted = ref(true);
    var flowUsed = computed(function () {
      return props.flowCount - props.flowSurplus;
    });
    // 已使用的流量百分比
    var flowUsedPercentage = computed(function () {
      var flowSurplus = props.flowSurplus,
        flowCount = props.flowCount;
      var billUsedFlow = flowCount - flowSurplus;
      if (beforeMounted.value) return "-100%";
      return "".concat(billUsedFlow / flowCount * 100 - 100, "%");
    });
    var flowUsedFormatted = computed(function () {
      var flowCount = props.flowCount;
      if (flowCount <= 1024) return formatFlowValue(unref(flowUsed), "MB");else return formatFlowValue(unref(flowUsed), "GB");
    });
    var flowCountFormatted = computed(function () {
      var flowCount = props.flowCount;
      if (flowCount <= 1024) return formatFlowValue(flowCount, "MB");else return formatFlowValue(flowCount, "GB");
    });
    var formatFlowValue = function (value, unit) {
      if (unit === "MB") return ~~(value * 100) / 100 + "MB";
      return ~~(value / 1024 * 100) / 100 + "GB";
    };
    onMounted(function () {
      setTimeout(function () {
        beforeMounted.value = false;
      }, 100);
    });
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", {
        class: "flow-percentage",
        style: _normalizeStyle({
          left: _unref(flowUsedPercentage)
        })
      }, null, 4)]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, "已用量 " + _toDisplayString(_unref(flowUsedFormatted)), 1), _createElementVNode("div", _hoisted_5, "总用量 " + _toDisplayString(_unref(flowCountFormatted)), 1)])]);
    };
  }
});